import React, { FormEvent, useState } from "react";

import ProfileImage from "../ProfileImage/ProfileImage";
import useCurrentUser from "../../hooks/useCurrentUser";

export interface ChatboxProps {
  onNewMessage: (comment: string) => void;
}

const Chatbox = ({ onNewMessage }: ChatboxProps) => {
  const [comment, setComment] = useState("");
  const currentUser = useCurrentUser();
  const { image } = currentUser || {};

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setComment("");
    onNewMessage(comment);
  };

  return (
    <div className="flex items-center justify-between w-full space-x-4">
      <div className="w-2/12">
        <ProfileImage src={image} />
      </div>
      <div className="flex justify-center w-full">
        <form className="w-full" onSubmit={handleSubmit}>
          <input
            className="w-full p-2 px-4 text-sm bg-white border rounded-full focus:outline-none"
            type="text"
            placeholder="Write something..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </form>
      </div>
    </div>
  );
};

export default Chatbox;
